export class MachineDefinitionUpdateCommand {
  private name: string;
  private type: string;
  private updateImage: string;
  private telemetry: UpdateMachineTelemetryCommand[] = [];
  private alarms: object;
  private notifications: object;
  private graphs: object;

  constructor(data: any) {
    this.name = data.name ?? "";
    this.type = data.type ?? "";
    this.updateImage = data.updateImage ?? false;

    const telemetryData = data.telemetry as [any];
    telemetryData.forEach((data) =>
      this.telemetry.push(UpdateMachineTelemetryCommand.fromJson(data))
    );

    this.alarms = data.alarms;
    this.notifications = data.notifications;
    this.graphs = data.graphs;
  }

  static fromJson(data: any) {
    return new MachineDefinitionUpdateCommand(data);
  }
}

export class UpdateMachineTelemetryCommand {
  private id: string | undefined;
  private name: string;
  private label: string;
  private unit: string;
  private type: string;
  private log: boolean;
  private sms: boolean;
  private dataType: string;
  private groupId: string | undefined;

  constructor(data: any) {
    this.id = data.id ?? undefined;
    this.name = data.name ?? "";
    this.label = data.label;
    this.unit = data.unit;
    this.type = data.type;
    this.log = data.log;
    this.sms = data.sms;
    this.dataType = data.dataType;
    this.groupId = data.group?.id ?? undefined;
  }

  static fromJson(data: any) {
    return new UpdateMachineTelemetryCommand(data);
  }
}
